import cn from 'classnames';
import { CSSProperties, FC } from 'react';
import './styles.scss';

type Props = {
  className?: string;
  style?: CSSProperties;
};

const SkeletonButton: FC<Props> = ({ className, style }) => (
  <div className={cn('skeleton_button', className)} style={style} aria-hidden="true" />
);

export default SkeletonButton;
